export default __webpack_public_path__ + "static/media/placeholder_business06-es-mobile.636c6d41.png";